<script setup lang="ts">
import { getYear } from 'date-fns'

const year = getYear(new Date())

</script>

<template>
  <div>
    <div
      class="w-full bg-surface-grey text-v2-tertiary
    flex flex-col gap-2 text-sm font-medium text-center px-2 py-8 text-balance"
    >
      <p>
        Banking services are provided by Column N.A., member FDIC.
        “Column” is a registered trademark of Column National Association.
      </p>
      <p>Copyright © {{ year }} Giftly. All rights reserved.</p>
    </div>
  </div>
</template>
